import { render, staticRenderFns } from "./chart_item.vue?vue&type=template&id=2a56f5b9&scoped=true"
import script from "./chart_item.vue?vue&type=script&lang=js"
export * from "./chart_item.vue?vue&type=script&lang=js"
import style0 from "./chart_item.vue?vue&type=style&index=0&id=2a56f5b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56f5b9",
  null
  
)

export default component.exports